<div
  #pop="atxPopover"
  [atxPopover]="datePicker"
  autoClose="outside"
  class="input-group mb-0"
>
  <div class="input-group-prepend">
    <button
      class="btn btn-light border d-flex align-items-center"
      type="button"
      [disabled]="inputControl.disabled"
      (click)="pop.open()"
    >
      <fa-icon [icon]="['fas', 'calendar-days']"></fa-icon>
    </button>
  </div>
  <input
    atxTooltip="UTC time is used"
    i18n-atxTooltip="DateInput|Date input tooltip utc@@dateInputUtcTooltip"
    [tooltipEnabled]="useUtcLocale"
    class="form-control"
    [formControl]="inputControl"
    [placeholder]="placeholder"
    type="text"
    autocomplete="off"
    readonly="true"
  />
  <div class="input-group-append" *ngIf="allowClear && !!inputControl.value">
    <button
      class="btn btn-light border d-flex align-items-center"
      type="button"
      (click)="clear(); pop.close(); $event.stopPropagation()"
    >
      <fa-icon [icon]="['fas', 'trash']"></fa-icon>
    </button>
  </div>
  <ng-template #datePicker>
    @if (selectTime) {
    <atx-datetime-picker
      [minDate]="minDate"
      [maxDate]="maxDate"
      [startDate]="startDate"
      (dateSelected)="pop.close(); dateSelected($event)"
      (canceled)="pop.close()"
    >
    </atx-datetime-picker>
    } @else {
    <atx-date-picker
      [minDate]="minDate"
      [maxDate]="maxDate"
      [startDate]="startDate"
      (dateSelect)="pop.close(); dateSelected($event)"
    ></atx-date-picker>
    }
  </ng-template>
</div>
